import { useLocation } from 'react-router-dom';

import get from 'lodash/get';
import keyBy from 'lodash/keyBy';

import { Box, List, styled } from '@sbv-clients/ui-shared';

import { SideBarMenuItem } from '../types';
import SidebarNavSection from './sidebar-nav-section';
import SidebarNavSectionWithChildren from './sidebar-nav-section-with-childrens';

const SideMenu = styled(Box)`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.text?.secondary};
  flex-grow: 1;
`;

const SideBarItems = ({ items }: { items: SideBarMenuItem[] }) => {
  const router = useLocation();
  const currentRoute = router.pathname;

  return (
    <>
      {items.map((item) => {
        const { id, link } = item;
        const children = get(item, 'children', []);
        if (children.length === 0) {
          const active =
            link === currentRoute ||
            (currentRoute.startsWith(link as string) && link !== '/');
          return (
            <SidebarNavSection key={id} item={item} active={active} withLink />
          );
        } else {
          const childrenItems = keyBy(children, 'link');
          return (
            <SidebarNavSectionWithChildren
              key={id}
              item={item}
              active={!!childrenItems[currentRoute]}
            />
          );
        }
      })}
    </>
  );
};

const SidebarNav = ({ items }: { items: SideBarMenuItem[] }) => {
  return (
    <SideMenu>
      <List>
        <Box>
          <SideBarItems items={items} />
        </Box>
      </List>
    </SideMenu>
  );
};

export default SidebarNav;
